// extracted by mini-css-extract-plugin
module.exports = {"responsiveVideo":"Video-module--responsiveVideo--2Uaaa","fullscreenVideo":"Video-module--fullscreenVideo--kt6k7","overlayGrey":"Video-module--overlayGrey--jX961"};